import { debug } from "../App";
import Member from "../types/Member";
import ApiService from "./ApiService";
import StorageService from "./StorageService";

export default class MemberService {
  private static cacheEnabled: boolean = false;

  static async getMember(includeUser: boolean = false): Promise<Member | null> {
    debug("MemberService: Getting member from storage");
    //let user = (await StorageService.get({key: 'user'})).value;
    let user = "{}";
    debug("MemberService: Got user from storage", user);

    if (user && this.cacheEnabled) {
      return Promise.resolve(JSON.parse(user || "{}"));
    } else {
      return await ApiService.get("members/me?")
        .then((memberData) => {
          debug("MemberService: Got member data from API", memberData);
          StorageService.set({ key: "user", value: JSON.stringify(user) });

          return Member.fromArray(memberData);
        })
        .catch((err) => {
          debug("MemberService: Error getting member from API", err);
          return Promise.resolve(null);
        });
    }
  }

  static async clearMember() {
    debug("MemberService: Clearing member from storage");
    await StorageService.remove({ key: "user" });
  }
}
